<gpu-form-field class="gmt-24" [appearance]="formFieldAppearance">
  <gpu-label>
    {{ 'ANALYSES.ADD.DATE' | translate }}
  </gpu-label>
  <input
    id="value-date"
    name="date"
    type="text"
    gpuDatepicker
    [placeholder]="'ANALYSES.ADD.DATE' | translate"
    ngbDatepicker
    #datepicker="ngbDatepicker"
    [datepicker]="datepicker"
    [maxDate]="now"
    [minDate]="minDate"
    container="body"
    [formControl]="form.get('date')"
  />
  <i gpuSuffix class="gpicon-calendar"></i>
  <gpu-error *ngIf="form.controls.date?.errors?.required">
    {{ 'ANALYSES.ADD.REQUIRED' | translate }}
  </gpu-error>
</gpu-form-field>
